<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-3.jpg)' }"
  class="content-header"
>
  <h2 class="header-title">Pilots</h2>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="section-container">
  <div class="random-actions">
    <!-- <span class="base"> Base: {{ userBase }}</span> -->
    <div class="app-dropdown" *ngIf="userIsSysAdmin && bases !== []">
      <app-dropdown
        [choice]="selectedBase"
        [options]="bases"
        key="name"
        label="Base"
        (selectedDropdownItem)="selectHomeBase($event)"
      ></app-dropdown>
    </div> 
    <div *ngIf="!userIsSysAdmin || bases === []">
      <span class="base"> Base: {{ userInfo.baseName }} ({{ userInfo.baseCode }})</span>      
    </div>

  </div>
  <app-table
    hasActions="true"
    [settings]="settings"
    [rows]="pilots"
    [columns]="headings"
    (deleted)="confirmDeletePilot($event)"
    [tableCellTemplate]="cellTemplate"
  >
    <ng-template #cellTemplate let-cell="cell">
      <div class="cell">
        <span>{{ cell.value }}</span>
      </div>
    </ng-template>
  </app-table>
</div>